import { uniq } from 'lodash-es';
import type { FC, PropsWithChildren } from 'react';
import { useState } from 'react';

import BulkSelectionContext from './BulkSelectionContext';
import type { BulkSelection } from './types';

export const BulkSelectionContextProvider: FC<PropsWithChildren<{}>> = ({ children }) => {
  const [bulkSelection, setBulkSelection] = useState<BulkSelection>({});

  const setBulkItemSelectedItems = (bulkItemKey: string, items: string[]): void => {
    setBulkSelection({ ...bulkSelection, [bulkItemKey]: items });
  };

  const addItems = (bulkItemKey: string, itemsToAdd: string[]): void => {
    const selectedItemsExist: boolean = bulkSelection?.[bulkItemKey]?.length > 0;
    const selectedItems: string[] = selectedItemsExist ? bulkSelection[bulkItemKey] : [];

    setBulkItemSelectedItems(bulkItemKey, uniq([...selectedItems, ...itemsToAdd]));
  };

  const clearBulkSelection = (): void => {
    const newBulkSelection: BulkSelection = {};

    Object.keys(bulkSelection).forEach((bulkSelectionKey: string) => {
      newBulkSelection[bulkSelectionKey] = [];
    });

    setBulkSelection(newBulkSelection);
  };

  const getItems = (bulkItemKey: string): string[] => {
    return bulkSelection[bulkItemKey] || [];
  };

  const removeItems = (bulkItemKey: string, itemsToRemove: string[]) => {
    let newSelectedItemsList: string[] = [];

    if (itemsToRemove.length !== 0) {
      newSelectedItemsList = bulkSelection[bulkItemKey]?.filter((selectedItem: string) => !itemsToRemove.includes(selectedItem));
    }

    setBulkItemSelectedItems(bulkItemKey, newSelectedItemsList);
  };

  return (
    <BulkSelectionContext.Provider
      value={{
        addItems,
        clearBulkSelection,
        getItems,
        removeItems
      }}
    >
      {children}
    </BulkSelectionContext.Provider>
  );
};

export default BulkSelectionContext;
